import { ReactNode } from 'react';
import styled from 'styled-components';
import { Box } from '@ardoq/layout';

export type DrawerFooterProps = {
  children: ReactNode;
};

const DrawerFooterStyle = styled(Box)`
  flex-shrink: 0;
`;

export const DrawerFooter = ({ children }: DrawerFooterProps) => (
  <DrawerFooterStyle
    paddingX="large"
    paddingY="medium"
    borderWidthTop={1}
    borderColor="borderSubtle"
  >
    {children}
  </DrawerFooterStyle>
);
